module.exports = __webpack_public_path__ + "img/USA-Worst-2010 - 2039.3f0017ac.png";